<template>
  <div id="warranty_content">
    <!--<van-nav-bar
      title="报修内容"
      left-text="返回"
      :right-text="rightContent"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />-->
    <div style="overflow: hidden; margin-top: 10px; margin-bottom: 20px;">
      <div style="float: left; margin-left: 10px;" @click="onClickLeft">
        <van-icon name="arrow-left" /> 返回
      </div>
      <div style="float: right;margin-right: 20px;">
        <div @click="clickMenu">
          <img src="@/assets/menu.png" style="width: 30px; height: 30px;" />
        </div>
        <!--<div style="float: left;margin-right: 10px; color: #1989fa;" @click="forwardWorker">施工人员</div>
        <div style="float: left;margin-right: 10px; color: #1989fa;" @click="forwardReport">施工报告</div>
        <div style="float: left; margin-left: 10px; color: #1989fa;" @click="forwardReim">报销单</div>-->
      </div>
    </div>
    <div style="width: 320px; margin: 0 auto 1vh; overflow: hidden;">
      <div style="width: 150px; background-color: #1989fa; color: #FFFFFF; margin-right: 10px; text-align: center; float: left; border-radius: 2px; height: 30px; line-height: 30px;" @click="forwardWorker">施工人员信息</div>
      <div style="width: 150px; background-color: #1989fa; color: #FFFFFF; text-align: center; float: left; border-radius: 2px; height: 30px; line-height: 30px;" @click="forwardReport">报告单</div>
    </div>
    <div style="width: 320px; margin: 0 auto 2vh; overflow: hidden;">
      <div style="width: 150px; text-align: center; background-color: #1989fa; color: #FFFFFF; margin-right: 10px; border-radius: 2px; height: 30px; line-height: 30px; float: left;" @click="forwardReim(0)">报销单</div>
      <div style="width: 150px; text-align: center; background-color: #1989fa; color: #FFFFFF; border-radius: 2px; height: 30px; line-height: 30px; float: left;" @click="forwardReim(1)">预报价</div>
    </div>
    <div>
      <div v-if="!result.callback_at" style="width: 150px; text-align: center; background-color: #1989fa; color: #FFFFFF; border-radius: 2px; height: 30px; line-height: 30px; margin: 0 auto;" @click="reportCard">到店打卡</div>
      <div @click="modifyOrder">修改订单</div>
    </div>
    <van-form v-if="result && result.submit_co_info_button && result.submit_co_info_button.is_show === 1" validate-first @failed="onFailed" style="margin-bottom: 20px" @submit="onSubmit">
        <van-cell title="上次拒绝理由" v-if="repairForm.status === 'reject'" :value="repairForm.approve_reason" />
        <van-cell title="上门维修开始时间" :value="repairForm.ma_start_at" style="text-align: left;" @click="showRepairStartTime = true" />
        <van-popup v-model="showRepairStartTime" position="bottom">
          <van-datetime-picker
            type="datehour"
            title="选择年月日小时"
            :min-date="minDate"
            @confirm="selectStartDate"
          />
        </van-popup>
        <van-cell title="上门维修结束时间" :value="repairForm.ma_end_at" style="text-align: left;" @click="showRepairEndTime = true" />
        <van-popup v-model="showRepairEndTime" position="bottom">
          <van-datetime-picker
            type="datehour"
            title="选择年月日小时"
            :min-date="minDate"
            @confirm="selectEndDate"
          />
        </van-popup>
        <van-cell title="选择工人" style="text-align: left;" @click="showSelectWorker = true" is-link/>
        <div v-if="repairForm.selectedWorkers">
          <div class="worker-list" v-for="(item, index) in repairForm.selectedWorkers" v-bind:key="index">
            <div class="worker-name">{{ item.show }}</div>
            <div class="worker-operation" @click="deleteWorker(index, item)">
              <van-icon name="delete-o" />
            </div>
          </div>
        </div>
        <van-popup v-model="showSelectWorker"
                   position="bottom"
                   :style="{ height: '60%' }"
                   closeable
                   close-icon="close"
        >
            <van-search
              style="margin-top: 40px"
              placeholder="搜索用户信息"
              v-model="searchData"
              @search="getUserList()"
              @input="getUserList()"
              @clear="getUserList()"
            ></van-search>
            <van-checkbox-group
              ref="checkboxGroup"
              @change="change"
              v-model="checkedValue"
            >
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in workers"
                  clickable
                  :key="item.id"
                  :title="item.show"
                  @click="toggle(index)"
                >
                  <template #right-icon>
                    <van-checkbox :name="item.id" ref="checkboxes" shape="square" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
            <van-button native-type="button"  @click="submitSelectedUser" style="width: 150px; border-radius: 10px; position: fixed; bottom: 20px; right: 30%;" type="info">确定</van-button>
        </van-popup>
        <van-field
          v-model="repairForm.submit_remark"
          name="备注"
          type="textarea"
          label="备注"
          placeholder="备注"
        />
        <van-button type="info" style="margin-top: 10px;margin-bottom:10px; width: 50%;">提交</van-button>
    </van-form>
    <div v-for="(item, index) in details" :key="index">
      <div style="width: 92%; font-size: 12px; margin: 10px auto 0px; text-align: left; ">
        <span :style="{'color': colorRelation[item.title.action_node_color]}" >{{ item.title.action_node_person }}</span>
        {{ item.title.action_node_value }}</div>
      <div style="width: 92%; font-size: 12px; text-align: left; margin: 5px auto 5px;">{{ item.title.action_node_at }}</div>
      <div style="background-color: #ffffff;width: 92%; border-radius: 20px; margin: 0 auto 2px;">
        <div v-for="(val, key) in item.body" class="content-detail" :key="key">
          <van-field v-if="val.t ==='text' " type="textarea"
                     rows="1"
                     autosize
                     :label="val.k" name="" :value="val.v" readonly />
          <van-field v-if="val.t ==='files' " name="" :label="val.k"  readonly>
            <template #input>
              <div>
                <van-image
                  v-for="(item, index) in val.v"
                  width="100"
                  height="100"
                  :key="index"
                  :src="item.file_url_thumb"
                  style="margin-right: 10px;"
                  @click="showPicture(val.enough_list, index)"
                  disabled
                />
              </div>
            </template>
          </van-field>
          <div v-if="val.t === 'rate'" style="width: 90%; margin: 10px auto;">
            <div style="text-align: left">{{ val.k }}</div>
            <v-chart style="width: 80%; height: 250px;" class="chart" autosize :option="option" />
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showUpdateInfoPicker" position="bottom" :style="{ height: '100%', backgroundColor: '#f7f8fa' }">
      <update-info :annex-id="annexId" @hideInfo="hideInfo"></update-info>
    </van-popup>
    <van-popup v-model="showMenu" position="right" :style="{ height: '100%', width: '50%' }">
      <van-cell title="施工人员信息" is-link @click="forwardWorker" />
      <van-cell title="报告单" is-link @click="forwardReport" />
      <van-cell title="报销单" is-link @click="forwardReim" />
      <van-cell v-if="showRepairReport" title="施工报告单" is-link @click="forwardRepairReport" />
    </van-popup>
  </div>
</template>

<script>
import {Toast} from 'vant'
import { ImagePreview } from "vant"
import {getDetail,saveReport,searchWorkers, details} from '@/api/order'
import updateInfo from './components/update_info'
import {getNodeList, getSubmitInfo, postCard, submitAppoTask} from "../../api/order";
import * as echarts from 'echarts'
import VChart, { THEME_KEY } from "vue-echarts";
import {getReportList} from "../../api/report";

const TYPES = ['定期维护', '紧急维修']
const STATUS = ['', '', '', '管理端确认信息', '完工报告', '管理端确认报告', '店铺端确认完工', '店铺端要求返工', '评价完成']
const COLOR_RELATION = {
  'yellow': '#E6A23C',
  'red': '#F56C6C',
  'green': '#67C23A',
  'blue': '#409EFF'
}

export default {
  name: 'warrantyDetail',
  components: {
    updateInfo,
    VChart
  },
  props: {
    showContent: {
      type: Object,
      default: null
    },
    showId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showMenu: false,
      showRepairReport: false,
      colorRelation: COLOR_RELATION,
      order_id: '',
      checkedValue: [],
      option: {},
      postForm: {
        id: undefined,
        img_urls: [],
        remark: '',
        category: {
          'level1': '',
          'level2': ''
        },
        brand: '测试',
        store_name: '店铺名',
        repair_type: '紧急维修',
        status_cn: '待维修',
        status: 1,
        service_remark: '服务备注',
        service_category: '固定/空调',
        repair_picture: '维修图片',
        selectedCategory: '',
        repair_desc: '维修内容',
      },
      rightContent: '',
      repairForm: {
        repair_time: '',
        submit_remark: '',
        ma_start_at: '',
        ma_end_at: '',
        man_ids: [],
        worker_ids: '',
        appo_task_id: '',
        selectedWorkers: []
      },
      showPicker: false,
      columns: [],
      imageList: [],
      categories: {},
      cascaderValue: '',
      showRepairEndTime: false,
      showRepairStartTime: false,
      minDate: new Date(),
      showSelectWorker: false,
      workers: [],
      searchData: '',
      details: [],
      buttons: {},
      result: {},
      is_worker: 0,
      annexId: null,
      showUpdateInfoPicker: false
    }
  },
  created () {
    const id = localStorage.getItem('id')
    if (1 == id || 4 == id || 529 == id || 115 == id) {
      this.showRepairReport = true
    }

    if (this.$route.query.is_worker && parseInt(this.$route.query.is_worker) === 1) {
      this.is_worker = parseInt(this.$route.query.is_worker)
    }
    this.initPostForm()
    this.initData()
    this.getSubmitInfo()
  },
  mounted() {
    //const chartDom = document.getElementById('rate')
    //console.log('chartDom....', chartDom)
    //if (chartDom !== null && typeof chartDom !== 'undefined') {
      //const myChart = echarts.init(chartDom)

      // option && myChart.setOption(option)
    //}
  },
  methods: {
    modifyOrder() {
      this.$router.push({path: '/order_create', query: {id: this.$route.query.id}})
    },
    reportCard() {
      if (window.navigator.geolocation){
        let options = {
          enableHighAccuracy : true,
          maximumAge : 30000,
          timeout :12000
        }
        window.navigator.geolocation.getCurrentPosition(this.getPosSuccess, this.getPosError, options);
      }else{
        console.log('当前环境不支持')
      }
    },
    getPosSuccess(pos){
      console.log(`纬度:${pos.coords.latitude}  经度:${pos.coords.longitude}`)
      postCard({appo_task_id: this.$route.query.appo_task_id, lat: pos.coords.latitude, lng: pos.coords.longitude}).then((res) => {
        console.log('res........s.s.s.s.....', res)
        if (res.data.code == 0) {
          Toast('打卡成功')
          this.initData()
          this.getSubmitInfo()
        }
      })
    },
    getPosError(err){
      console.log(err)
    },
    clickMenu() {
      this.showMenu = true
    },
    forwardWorker() {
      this.$router.push({path: '/order_worker', query: {order_worker_id: this.$route.query.order_worker_id, ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id }})
    },
    deleteWorker(index, value) {
      this.repairForm.selectedWorkers.splice(index, 1)
      this.repairForm.man_ids.splice(index, 1)
    },
    hideInfo() {
      this.showUpdateInfoPicker = false
    },
    getSubmitInfo() {
      if (this.$route.query.appo_task_id) {
        getSubmitInfo({ appo_task_id: this.$route.query.appo_task_id }).then((res) => {
          if (res.data.data) {
            this.order_id = res.data.data.order_id
            this.repairForm.appo_task_id = this.$route.query.appo_task_id
            this.repairForm.ma_start_at = res.data.data.ma_start_at
            this.repairForm.ma_end_at = res.data.data.ma_end_at
            this.repairForm.submit_remark = res.data.data.submit_remark
            this.repairForm.status = res.data.data.status
            this.repairForm.report_id = res.data.data.report_id
            this.repairForm.approve_reason = res.data.data.approve_reason
            this.repairForm.order_supplier_id = res.data.data.order_supplier_id
            this.result = res.data.data
            this.repairForm.selectedWorkers = []
            for (const i in res.data.data.worker_list) {
              this.repairForm.selectedWorkers.push({show: res.data.data.worker_list[i].worker})
              this.repairForm.man_ids.push(res.data.data.worker_list[i].worker_id)
            }
            if (res.data.data && res.data.data.submit_co_report_button && res.data.data.submit_co_report_button.is_show === 1) {
              this.rightContent = '提交施工报告'
            }
            if (res.data.data && res.data.data.submit_co_report_button && res.data.data.submit_co_report_button.is_show === 0 && res.data.data.submit_co_info_button.is_show === 0) {
              this.rightContent = '提交报销单'
            }
          }
        })
      }
    },
    submitSelectedUser() {
      if (this.checkedValue.length > 0) {
        for (const i in this.checkedValue) {
          if (this.repairForm.man_ids.indexOf(this.checkedValue[i]) > -1) {
            continue
          }
          this.repairForm.man_ids.push(this.checkedValue[i])
          for (const j in this.workers) {
            if (this.checkedValue[i] === this.workers[j].id) {
              this.repairForm.selectedWorkers.push(this.workers[j])
              break
            }
          }
        }
        this.showSelectWorker = false
        this.workers = []
        this.checkedValue = []
      }
    },
    change() {
    },
    initData() {
      getNodeList({ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id}).then((res) => {
        if (res.data.data) {
          this.details = res.data.data
          let rates = []
          for (const i in this.details) {
            if (this.details[i].body) {
              for (const j in this.details[i].body) {
                if (this.details[i].body[j].t === 'rate') {
                  rates = this.details[i].body[j].v
                }
              }
            }
          }
          const option = {
            radar: {
              indicator: [
                { name: '维修质量', max: 5 },
                { name: '维修速度', max: 5 },
                { name: '服务态度', max: 5 },
                { name: '准时上门', max: 5 },
                { name: '仪容仪表', max: 5 }
              ]
            },
            series: [
              {
                name: '评分',
                type: 'radar',
                data: [
                  {
                    value: rates,
                    name: 'Actual Spending',
                    itemStyle: {
                      normal: {
                        color: '#fb7299'
                      }
                    },
                    areaStyle: {
                      color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                        {
                          color: 'rgba(255, 145, 124, 0.1)',
                          offset: 0
                        },
                        {
                          color: 'rgba(255, 145, 124, 0.9)',
                          offset: 1
                        }
                      ])
                    }
                  }
                ]
              }
            ]
          }

          this.option = option
        }
      })
    },
    initPostForm () {
      if (this.$route.query.id) {
        getDetail(this.$route.query.id).then((res) => {
          if (res.data.data) {
            this.postForm = res.data.data
            this.postForm.appointment_at = res.data.data.appointment_at ? res.data.data.appointment_at.replace(/ 00:00:00/, '') : ''
            this.postForm.repair_type = TYPES[this.postForm.type]
            this.postForm.status_cn = STATUS[this.postForm.status]
          }
        })
      }
    },
    toggle(id) {
      console.log(this.$refs.checkbox)
      console.log(id)
    },
    getUserList() {
      if (this.searchData !== '' && typeof this.searchData !== 'undefined') {
        searchWorkers({search: this.searchData}).then(res => {
          this.workers = res.data.data
        })
      }

    },
    initColumns () {

    },
    onFailed (errorInfo) {
      console.log('failed', errorInfo)
    },
    onClickLeft () {
      this.$router.push({ path: '/warranty_list' })
    },
    onConfirm (value, index) {

    },
    onChange (picker, values) {
      console.log(picker, values)
    },
    onSubmit () {
      if (this.$route.query.appo_task_id) {
        this.repairForm.appo_task_id = this.$route.query.appo_task_id
        this.repairForm.worker_ids = this.repairForm.man_ids.join(',')
        submitAppoTask(this.repairForm).then((res) => {
          if (res.data.code === 0) {
            Toast('提交成功')
            setTimeout(() => {
              this.$router.push({path: '/warranty_list'})
            }, 1000)
          }
        })
      }
    },
    selectStartDate (val) {
      this.showRepairStartTime = false;
      this.repairForm.ma_start_at = this.formatDate(val);
    },
    selectEndDate (val) {
      this.showRepairEndTime = false;
      this.repairForm.ma_end_at = this.formatDate(val)
    },
    formatDate(date) {
      return  `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:00`;
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    },
    async forwardReport() {
      let list = []
      let queryData = {page: 1, page_size: 50, order_supplier_id: this.repairForm.order_supplier_id}
      /*if (!this.isMobile()) {
        await this.$router.push({
          name: 'ReportListPC', params: {
            order_worker_id: this.$route.query.order_worker_id,
            ma_item_id: this.$route.query.ma_item_id,
            appo_task_id: this.$route.query.appo_task_id,
            order_id: this.order_id,
            order_supplier_id: this.repairForm.order_supplier_id
          }
        })
        return
      }*/
      await getReportList(queryData).then((res) => {
        if (res.data.data.list) {
          const data = res.data.data.list
          if (data.length < 20) {
            this.finished = true
          }
          list = data
        } else {
          this.finished = true
          list = []
        }
      })
      if (list.length > 0) {
        await this.$router.push({
          path: '/order_report_list',
          query: {
            order_worker_id: this.$route.query.order_worker_id,
            ma_item_id: this.$route.query.ma_item_id,
            appo_task_id: this.$route.query.appo_task_id,
            order_id: this.order_id,
            order_supplier_id: this.repairForm.order_supplier_id
          }
        });
      } else {
        await this.$router.push({path: '/order_create_report',
          query: {
            order_worker_id: this.$route.query.order_worker_id,
            ma_item_id: this.$route.query.ma_item_id,
            appo_task_id: this.$route.query.appo_task_id,
            order_id: this.order_id,
            report_id: this.repairForm.report_id,
            order_supplier_id: this.repairForm.order_supplier_id
          }
        })
      }

      // this.$router.push({path: '/order_create_report', query: {order_worker_id: this.$route.query.order_worker_id, ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id, order_id: this.order_id, report_id: this.repairForm.report_id, order_supplier_id: this.repairForm.order_supplier_id }})
      //this.$router.push({path: '/warranty_report', query: {order_worker_id: this.$route.query.order_worker_id, ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id }})
    },
    forwardReim(type) {
      if (this.isMobile()) {
        this.$router.push({path: '/order_reimbursement', query: {appo_task_id: this.$route.query.appo_task_id, ma_item_id: this.$route.query.ma_item_id, pre_quote_status: type }})
      } else {
        this.$router.push({path: '/warranty_pc_detail', query: {appo_task_id: this.$route.query.appo_task_id, ma_item_id: this.$route.query.ma_item_id, pre_quote_status: type}})
      }
    },
    forwardRepairReport() {
      this.$router.push({path: '/warranty_report', query: {order_worker_id: this.$route.query.order_worker_id, ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id, order_id: this.order_id }})
    },
    onClickRight () {
      if (this.rightContent === '提交施工报告') {
        this.$router.push({path: '/warranty_report', query: {order_worker_id: this.$route.query.order_worker_id, ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id, order_id: this.order_id }})
      }
      if (this.rightContent === '提交报销单') {
        if (this.isMobile()) {
          this.$router.push({path: '/order_reimbursement', query: {appo_task_id: this.$route.query.appo_task_id }})
        } else {
          this.$router.push({path: '/warranty_pc_detail', query: {appo_task_id: this.$route.query.appo_task_id }})
        }
        return false
      }
      if (this.rightContent === '更新个人信息') {
        this.showUpdateInfoPicker = true
        return false
      }
      if (this.postForm.status > 3 && this.postForm.status !== 7) {
        if (this.isMobile()) {
          this.$router.push({path: '/order_reimbursement', query: {annex_id: this.$route.query.annex_id, maintenance_id: this.$route.query.id }})
        } else {
          this.$router.push({path: '/warranty_pc_detail', query: {annex_id: this.$route.query.annex_id, maintenance_id: this.$route.query.id }})
        }
        return false
      }
      if (this.$route.query.id) {
        this.$router.push({path: '/warranty_report', query: {id: this.$route.query.id, annex_id: this.$route.query.annex_id }})
      }
    },
    showPicture (images, index) {
      ImagePreview({
        images: images,
        showIndex: true,
        loop: false,
        startPosition: index
      })
    }
  }
}
</script>

<style scoped>
.worker-list {
  overflow: hidden;
  width: 90%;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
}
.worker-name {
  float: left;
  padding-left: 30px;
}
.worker-operation {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/order/detail.vue